module.exports = __webpack_public_path__ + "img/index04.1024e8d6.png";